var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-empty"},[_c('a-icon',{staticClass:"search-empty-icon",attrs:{"type":"search"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.cMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }